import { PriceFieldHandlerParams } from './types';

export function handleNoOp(_params: PriceFieldHandlerParams) {
  return;
}
